import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link,useOutletContext } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import ProgressBar from "react-bootstrap/ProgressBar";
import { MaterialReactTable } from "material-react-table";
import { colors } from "@mui/material";
import ByIndustry from "../../order/components/ByIndustry";
import ByGeography from "../../order/components/ByGeography";


function SectorReport() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  
  const [selectedYear, setSelectedYear] = useState(currentFY);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_sector_report/`,
        {
            params: { year: selectedYear },
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setoptions(response.data.report_list || []);
        setRegionOptions(response.data.sector_region_revenue || []);
        const d = response.data;
        if (response.status == 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

useEffect(() => {
  if (token && selectedYear) {
    fetchOptions();
  }
}, [token, selectedYear]); // 👈 add selectedYear

const topSector = [...options].sort(
  (a, b) => (b.achievement || 0) - (a.achievement || 0)
)[0]?.sector;

const grandTotal = options.reduce(
  (acc, row) => {
    acc.target += Number(row.target || 0);
    acc.achievement += Number(row.achievement || 0);
    acc.total_closed += Number(row.total_closed || 0);
    acc.total_active += Number(row.total_active || 0);
    acc.total_hold += Number(row.total_hold || 0);
    acc.new_clients += Number(row.new_clients || 0);
    acc.existing_clients += Number(row.existing_clients || 0);
    return acc;
  },
  {
    target: 0,
    achievement: 0,
    total_closed: 0,
    total_active: 0,
    total_hold: 0,
    new_clients: 0,
    existing_clients: 0,
  }
);

const grandRegionTotal = regionOptions.reduce(
  (acc, row) => {
    acc.Europe += Number(row.Europe || 0);
    acc.MEA += Number(row.MEA || 0);
    acc.India += Number(row.India || 0);
    acc.NorthAsia += Number(row["North Asia"] || row.NorthAsia || 0);
    acc.SEA += Number(row.SEA || 0);
    acc.Americas += Number(row.Americas || 0);
    acc.ANZ += Number(row.ANZ || 0);

    acc.achievement += Number(row.achievement || 0);
    acc.target += Number(row.target || 0);

    return acc;
  },
  {
    Europe: 0,
    MEA: 0,
    India: 0,
    NorthAsia: 0,
    SEA: 0,
    Americas: 0,
    ANZ: 0,
    achievement: 0,
    target: 0,
  }
);

grandRegionTotal.percentage =
  grandRegionTotal.target > 0
    ? ((grandRegionTotal.achievement / grandRegionTotal.target) * 100).toFixed(1)
    : 0;

  const financialYears = Array.from({ length: 5 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

    return (
        <>
        <div className="card">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Sector Report ({selectedYear})</h4>
                <div style={{ width: "150px" }}>
                    <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    >
                    {financialYears.map((fy) => (
                        <option key={fy.value} value={fy.value}>
                        {fy.label}
                        </option>
                    ))}
                    </select>
                </div>

                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="card-body">
                            <div className="table-responsive" style={{ maxHeight: "500px" }}>
                            <table className="table text-nowrap table-bordered">
                                <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                <tr>
                                    <th>Sector</th>
                                    <th>Europe</th>
                                    <th>MEA</th>
                                    <th>India</th>
                                    <th>North Asia</th>
                                    <th>SEA</th>
                                    <th>Americas</th>
                                    <th>ANZ</th>
                                    <th>Total</th>
                                    <th>Target</th>
                                    <th>%</th>
                                </tr>
                                </thead>

                                <tbody>
                                {regionOptions.map((row, index) => (
                                    <tr>
                                        <td>{row.sector}</td>
                                        <td>{formatNumber(Math.round(row.Europe || 0))}</td>
                                        <td>{formatNumber(Math.round(row.MEA || 0))}</td>
                                        <td>{formatNumber(Math.round(row.India || 0))}</td>
                                        <td>{formatNumber(Math.round(row.NorthAsia || 0))}</td>
                                        <td>{formatNumber(Math.round(row.SEA || 0))}</td>
                                        <td>{formatNumber(Math.round(row.Americas || 0))}</td>
                                        <td>{formatNumber(Math.round(row.ANZ || 0))}</td>
                                        <td>{formatNumber(Math.round(row.achievement || 0))}</td>
                                        <td>{formatNumber(Math.round(row.target || 0))}</td>
                                        <td>{row.percentage}</td>
                                    </tr>
                                ))}
                                </tbody>

                                <tfoot
                                style={{
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff",
                                    fontWeight: "bold",
                                    zIndex: 1,
                                }}
                                >
                                <tr style={{ background: "#f1f1f1" }}>
                                    <td>Grand Total</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.Europe || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.MEA || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.India || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.NorthAsia || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.SEA || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.Americas || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.ANZ || 0))}</td>
                                    <td>{formatNumber(Math.round(grandRegionTotal.achievement))}</td>
                                    <td>{formatNumber(grandRegionTotal.target)}</td>
                                    <td>{grandRegionTotal.percentage}</td>
                                </tr>
                                </tfoot>
                            </table>
                            </div>        
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 col-xl-6 col-xxl-6">
                        <div className="card flex-fill">
                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                                By Industry
                                <span className="fs-12 fw-light mt-1">
                                Business delivered by sector
                                </span>
                            </h5>
                            </div>
                            <div className="card-body">
                            <ByIndustry chart_data={data?.revenue_industry} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-6 col-xxl-6">
                        <div className="card flex-fill">
                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                                By Geography
                                <span className="fs-12 fw-light mt-1">
                                Business delivered by region
                                </span>
                            </h5>
                            </div>
                            <div className="card-body">
                            <ByGeography chart_data={data?.revenue_geography} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="card-body">
                            <div className="table-responsive" style={{ maxHeight: "500px" }}>
                            <table className="table text-nowrap table-bordered">
                                <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                <tr>
                                    <th>Sector</th>
                                    <th>Target</th>
                                    <th>Achievement</th>
                                    <th>Closed</th>
                                    <th>Active</th>
                                    <th>Hold/Shelved</th>
                                    <th>New Client</th>
                                    <th>Existing Client</th>
                                    <th>Average VOBT</th>
                                    <th>Average Fee</th>
                                    <th>ARPA</th>
                                    <th>Average Fee(VOBT)</th>
                                </tr>
                                </thead>

                                <tbody>
                                {options.map((row, index) => (
                                    <tr
                                    key={index}
                                    style={{
                                        background:
                                        row.sector === topSector ? "#e6f7ff" : "transparent",
                                        fontWeight:
                                        row.sector === topSector ? "600" : "normal",
                                    }}
                                    >
                                    <td>{row.sector}</td>
                                    <td>₹ {formatNumber(row.target)}</td>
                                    <td>₹ {formatNumber(row.achievement)}</td>
                                    <td>{row.total_closed}</td>
                                    <td>{row.total_active}</td>
                                    <td>{row.total_hold}</td>
                                    <td>{row.new_clients}</td>
                                    <td>{row.existing_clients}</td>
                                    <td>₹ {formatNumber(row.avg_vobt)}</td>
                                    <td>{row.avg_fee}</td>
                                    <td>₹ {formatNumber(row.arpa)}</td>
                                    <td>{row.avg_fee_vobt}</td>
                                    </tr>
                                ))}
                                </tbody>

                                <tfoot
                                style={{
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff",
                                    fontWeight: "bold",
                                    zIndex: 1,
                                }}
                                >
                                <tr style={{ background: "#f1f1f1" }}>
                                    <td>Grand Total</td>
                                    <td>₹ {formatNumber(grandTotal.target)}</td>
                                    <td>₹ {formatNumber(grandTotal.achievement)}</td>
                                    <td>{grandTotal.total_closed}</td>
                                    <td>{grandTotal.total_active}</td>
                                    <td>{grandTotal.total_hold}</td>
                                    <td>{grandTotal.new_clients}</td>
                                    <td>{grandTotal.existing_clients}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                </tfoot>
                            </table>
                            </div>        
                        </div>
                    </div>
                </div>
                                
            </div>
        </div>
        </>
    );
}

export default SectorReport;